import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { aboutData } from "@/mocks/aboutData";
import { faqData } from "@/mocks/aboutData";

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于我们 - 虚空韩漫网",
            description: "虚空韩漫网品牌介绍、平台特色、用户口碑及联系方式。",
            url: "https://xukongmanhua.com/about",
            isPartOf: {
              "@type": "WebSite",
              name: "虚空韩漫网",
              url: "https://xukongmanhua.com",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqData.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://xukongmanhua.com" },
              { "@type": "ListItem", position: 2, name: "关于我们" },
            ],
          }),
        }}
      />
      <main className="min-h-screen bg-background-50">
        <div className="pt-20 pb-6">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <Breadcrumb />
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-3 font-heading">
              关于我们
            </h1>
          </div>
        </div>

        <div className="max-w-[1200px] mx-auto px-4 md:px-6 pb-16">
          {/* Brand Intro */}
          <section className="mb-14">
            <div className="bg-white rounded-2xl border border-background-200 p-6 md:p-10">
              <div className="flex flex-col lg:flex-row gap-10 items-start">
                <div className="flex-1">
                  <h2 className="text-xl font-bold text-foreground-950 mb-2 font-heading">
                    {aboutData.brandName}
                  </h2>
                  <p className="text-lg text-primary-600 font-medium mb-4">
                    {aboutData.slogan}
                  </p>
                  <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                    {aboutData.introduction.split("\n\n").map((para, i) => (
                      <p key={i}>{para}</p>
                    ))}
                  </div>
                </div>
                <div className="lg:w-[360px] flex-shrink-0 flex flex-col gap-4">
                  <div className="bg-background-50 rounded-xl p-5">
                    <p className="text-sm font-semibold text-foreground-950 mb-2">
                      我们的愿景
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {aboutData.vision}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    {aboutData.stats.map((stat) => (
                      <div
                        key={stat.label}
                        className="bg-background-50 rounded-xl p-4 text-center"
                      >
                        <p className="text-2xl font-bold text-primary-600">
                          {stat.value}
                        </p>
                        <p className="text-xs text-foreground-500 mt-1">
                          {stat.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Features */}
          <section className="mb-14">
            <h2 className="text-xl font-bold text-foreground-950 mb-6 font-heading text-center">
              平台特色
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {aboutData.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border border-background-200 p-5 hover:border-background-300 transition-all"
                >
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center mb-3">
                    <i className={`${feature.icon} text-lg text-primary-600 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Reviews */}
          <section className="mb-14">
            <h2 className="text-xl font-bold text-foreground-950 mb-6 font-heading text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {aboutData.reviews.map((review, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border border-background-200 p-5"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">
                        {review.name}
                      </p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <i
                            key={i}
                            className="ri-star-fill text-yellow-400 text-xs w-3 h-3 flex items-center justify-center"
                          ></i>
                        ))}
                        {Array.from({ length: 5 - review.rating }).map((_, i) => (
                          <i
                            key={`e-${i}`}
                            className="ri-star-line text-foreground-300 text-xs w-3 h-3 flex items-center justify-center"
                          ></i>
                        ))}
                      </div>
                    </div>
                    <span className="ml-auto text-xs text-foreground-400">
                      {review.date}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {review.content}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-14">
            <h2 className="text-xl font-bold text-foreground-950 mb-6 font-heading text-center">
              联系我们
            </h2>
            <div className="bg-white rounded-2xl border border-background-200 p-6 md:p-10">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">
                      电子邮箱
                    </p>
                    <p className="text-sm text-foreground-600">
                      {aboutData.contactInfo.email}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">
                      微信
                    </p>
                    <p className="text-sm text-foreground-600">
                      {aboutData.contactInfo.wechat}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-weibo-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">
                      微博
                    </p>
                    <p className="text-sm text-foreground-600">
                      {aboutData.contactInfo.weibo}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-qq-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">
                      QQ
                    </p>
                    <p className="text-sm text-foreground-600">
                      {aboutData.contactInfo.qq}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">
                      工作时间
                    </p>
                    <p className="text-sm text-foreground-600">
                      {aboutData.contactInfo.workingHours}
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950 mb-1">
                      公司地址
                    </p>
                    <p className="text-sm text-foreground-600">
                      {aboutData.contactInfo.address}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ on About page */}
          <section>
            <h2 className="text-xl font-bold text-foreground-950 mb-6 font-heading text-center">
              常见问题
            </h2>
            <div className="max-w-[800px] mx-auto space-y-3">
              {faqData.slice(0, 5).map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border border-background-200 p-5"
                >
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">
                    {faq.question}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}